import script from "./Cards.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cards.vue?vue&type=script&setup=true&lang=ts"

import "./Cards.vue?vue&type=style&index=0&id=14c2b773&lang=scss&scoped=true"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c2b773"]])

export default __exports__